import { read } from './read';
import { searchFiltersMapper } from './searchFiltersMapper';

export default {
  searchFiltersMapper,
  read,
};
